import 'css-chunksrc/client/scenes/timeRecordsListingConfiguration/form/styles.scss';export default {
  "form": "_form_26prr_1",
  "group": "_group_26prr_5",
  "row": "_row_26prr_9",
  "label": "_label_26prr_19",
  "description": "_description_26prr_24",
  "roleSelection": "_roleSelection_26prr_28"
};